import type { ChangeEvent, FC, FormEvent } from 'react';

import Button from '@/common-components/Button';
import FormField from '@/common-components/FormField';
import Input from '@/common-components/Input';

interface LoginFormProps {
  email: string;
  password: string;
  errors: { email?: string; password?: string };
  submitError: string | null;
  isSubmitting: boolean;
  onChangeEmail: (event: ChangeEvent<HTMLInputElement>) => void;
  onChangePassword: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

const LoginForm: FC<LoginFormProps> = ({
  email,
  password,
  errors,
  submitError,
  isSubmitting,
  onChangeEmail,
  onChangePassword,
  onSubmit,
}) => (
  <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
    <FormField label="Email" htmlFor="login-email" error={errors.email}>
      <Input
        id="login-email"
        type="email"
        autoComplete="email"
        value={email}
        onChange={onChangeEmail}
        hasError={Boolean(errors.email)}
        placeholder="you@example.com"
      />
    </FormField>

    <FormField label="Password" htmlFor="login-password" error={errors.password}>
      <Input
        id="login-password"
        type="password"
        autoComplete="current-password"
        value={password}
        onChange={onChangePassword}
        hasError={Boolean(errors.password)}
        placeholder="At least 8 characters"
      />
    </FormField>

    {submitError ? (
      <p
        role="alert"
        className="rounded-md border border-[var(--color-danger)]/30 bg-[var(--color-danger-bg)] p-3 text-sm text-[var(--color-danger-ink)]"
      >
        {submitError}
      </p>
    ) : null}

    <Button type="submit" loading={isSubmitting} size="lg" className="mt-2">
      Log in
    </Button>
  </form>
);

export default LoginForm;
